import { EMPTY, Observable, OperatorFunction, map, switchMap, timer } from 'rxjs';

export function emitAfter<T, R>(value: R, getTimeoutMs: (source: NonNullable<T>) => number): OperatorFunction<T, R> {
    return (source$: Observable<T>) =>
        source$.pipe(
            switchMap((source) => {
                if (source != null) {
                    return timer(getTimeoutMs(source));
                }

                return EMPTY;
            }),
            map(() => value),
        );
}
